export const GET_USER_PROFILE = `
  query userProfile($userId: ID!) {
    userProfile(userId: $userId) {
      profile {
        name {
          first
          last
        }
        email
      }
      accountFlags {
        isAutoGeneratedPassword
      }
      userPreferences {
        preferredName
        preferredLanguage
      }
      account {
        thirdPartyLogin {
          google {
            isConnected
          }
          apple {
            isConnected
          }
          facebook {
            isConnected
          }
        }
      }
    }
    getLanguages {
      languages {
        name
        nativeName
      }
    }
  }
`;
